import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Input from './Input';
import YesNoMaybe from './YesNoMaybe';
import css from './styles.module.less';

type Props = {
  fieldName: string;
  value: boolean | string;
  pageName: 'building' | 'listing';
};

const YesNoMaybeWithSource = memo(({ fieldName, value, pageName }: Props) => {
  const { t } = useTranslation('admin');
  const valueNotNull = value != null && value !== '';

  const metadataPath = `amenitySet.${fieldName}`;

  return (
    <fieldset className={css.sideBySide}>
      <YesNoMaybe
        key={`${pageName}.${fieldName}`}
        containerClass={valueNotNull ? css.left : css.fullWidth}
        labelText={t(`${pageName}.${fieldName}`)}
        name={metadataPath}
        value={value}
      />
      {valueNotNull ? (
        <Input
          key={`${pageName}.${fieldName}DataSource`}
          containerClass={css.right}
          labelText={t(`${pageName}.dataSource`)}
          name={`${metadataPath}DataSource`}
        />
      ) : null}
    </fieldset>
  );
});

export default YesNoMaybeWithSource;
